import parser from './parser';

const name = 'switch';


export default {parser, name};
